export default function DownloadIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4 13.999H18C18.9319 13.999 19.3978 13.999 19.7654 14.1512C20.2554 14.3542 20.6448 14.7436 20.8478 15.2336C21 15.6012 21 16.0671 21 16.999C21 17.9309 21 18.3968 20.8478 18.7644C20.6448 19.2544 20.2554 19.6438 19.7654 19.8468C19.3978 19.999 18.9319 19.999 18 19.999H6C5.06812 19.999 4.60218 19.999 4.23463 19.8468C3.74458 19.6438 3.35523 19.2544 3.15224 18.7644C3 18.3968 3 17.9309 3 16.999C3 16.0671 3 15.6012 3.15224 15.2336C3.35523 14.7436 3.74458 14.3542 4.23463 14.1512C4.60218 13.999 5.06812 13.999 6 13.999H6.6M12 14.999V3.99902M12 14.999L9 11.999M12 14.999L15 11.999"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
